// UBQ-5212: invitation state on the Users screen. Values match the backend InvitationState enum
// exactly — they are sent as-is on GET /users and returned in the Status column.

/** Sent as the `inviteStatus` query param. Omitted entirely for "all". */
export enum InvitationStatusFilter {
    /**
     * Sent an invitation and hasn't signed in yet — the population bulk resend acts on. Deliberately
     * excludes deactivated users, who share the same underlying status but must never be re-invited.
     */
    INVITED = 'INVITED',
    /** Created but never sent an invitation. */
    NOT_INVITED = 'NOT_INVITED',
    /** Everyone who has signed in at least once. */
    ACCEPTED = 'ACCEPTED',
}

/**
 * Status labels the API returns in the Status column. Only the two awaiting-sign-in states can be sent
 * an invitation, so this is what the resend actions are gated on.
 */
export const USER_STATUS = {
    ACTIVE: 'Active',
    INVITED: 'Invited',
    /** Added to the account but never emailed. Invitable, like INVITED. */
    NOT_INVITED: 'Not invited',
    DEACTIVATED: 'Deactivated',
} as const

/** Verdicts that mean an address cannot be invited, so its chip turns red and blocks submit. */
export const BLOCKING_VERDICTS = [
    'already_active',
    'already_invited',
    'deactivated',
]

/** Cap enforced server-side by MAX_INVITES_PER_REQUEST; stated here so the UI can gate first. */
export const MAX_USERS_PER_BATCH = 200

/** Past this many addresses the confirmation warns about deliverability. The send is still allowed. */
export const WARN_THRESHOLD_USERS = 50
